import React from "react";
import { Icon } from "../Icon";

export type IconCategory = "tool" | "display" | "nav";

export interface SpecifiedIconButtonProps {
  /**
   * 아이콘 카테고리 (tool, display, nav)
   */
  category: IconCategory;
  /**
   * 아이콘 이름 (카테고리 디렉토리 내 파일명)
   */
  iconName: string;
  /**
   * 활성화 상태
   */
  active?: boolean;
  /**
   * 비활성화 상태
   */
  disabled?: boolean;
  /**
   * 툴팁 텍스트
   */
  tooltip?: string;
  /**
   * 클릭 핸들러
   */
  onClick?: () => void;
  /**
   * 추가 CSS 스타일 (MUI sx prop과 동일한 문법)
   */
  sx?: any;
  /**
   * CSS 클래스명
   */
  className?: string;
}

/**
 * IconButton 컴포넌트
 *
 * 24px 아이콘을 사용하는 버튼 컴포넌트입니다.
 * - 기본 상태: {category}/basic 디렉토리의 아이콘 사용
 * - 활성화 상태: {category}/mode 디렉토리의 아이콘 사용
 * - 비활성화 상태: {category}/disabled 디렉토리의 아이콘 사용
 *
 * 지원 카테고리: tool, display, nav
 */
export const SpecifiedIconButton: React.FC<SpecifiedIconButtonProps> = ({
  category,
  iconName,
  active = false,
  disabled = false,
  tooltip,
  onClick,
  sx,
  className,
}) => {
  // 상태에 따라 아이콘 경로 결정
  const getIconPath = () => {
    if (disabled) {
      return `24/${category}/disabled/${iconName}`;
    }
    if (active) {
      return `24/${category}/mode/${iconName}`;
    }
    return `24/${category}/basic/${iconName}`;
  };

  return (
    <div
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 32, // 24px 아이콘 + 8px 패딩
        height: 32,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        ...sx,
      }}
      onClick={disabled ? undefined : onClick}
      title={tooltip}
    >
      <Icon name={getIconPath()} size={24} color="currentColor" />
    </div>
  );
};

export default SpecifiedIconButton;
